import { useState } from 'react';
import { goToPhoneVersion, phoneOnFullConsole } from '../phoneRedirect';

/** Dismissed on this browser (a per-browser convenience, never the session). */
export const FULL_CONSOLE_NOTICE_KEY = 'aithora.fullConsoleNoticeDismissed';

function dismissed(): boolean {
  try {
    return window.localStorage.getItem(FULL_CONSOLE_NOTICE_KEY) === '1';
  } catch {
    return false;
  }
}

/**
 * A phone that chose the full console (?desktop=1, phoneRedirect.ts) is told so, with the
 * way back to the phone app. Matches the phone app's "You're viewing the phone version"
 * notice. Dismissing it hides it on this browser; "Phone version" stays in the account menu.
 */
export function FullConsoleNotice({ show = phoneOnFullConsole() }: { show?: boolean }) {
  const [hidden, setHidden] = useState(dismissed);
  if (!show || hidden) return null;
  const close = () => {
    try {
      window.localStorage.setItem(FULL_CONSOLE_NOTICE_KEY, '1');
    } catch {
      /* storage off: hidden for this page only */
    }
    setHidden(true);
  };
  return (
    <div role="status" className="fcnotice" data-testid="full-console-notice">
      <span className="fcnotice__text">
        {'You’re viewing the full console. '}
        <button type="button" className="fcnotice__link" onClick={goToPhoneVersion}>
          Switch to phone version
        </button>
      </span>
      <button type="button" className="fcnotice__close" aria-label="Hide this notice" onClick={close}>
        {'×'}
      </button>
    </div>
  );
}
